/**
 * Inline editor schema used by Editor.vue and by the URL-improve CI round trip.
 * Table is part of the schema so setData/getData keep scraped issue tables.
 * Structured rows and cells only — never a table node's raw outer HTML.
 */
import {InlineEditor} from '@ckeditor/ckeditor5-editor-inline';
import {Autoformat} from '@ckeditor/ckeditor5-autoformat';
import {Essentials} from '@ckeditor/ckeditor5-essentials';
import {Bold, Italic} from '@ckeditor/ckeditor5-basic-styles';
import {Link} from '@ckeditor/ckeditor5-link';
import {List} from '@ckeditor/ckeditor5-list';
import {Paragraph} from '@ckeditor/ckeditor5-paragraph';
import {Indent} from '@ckeditor/ckeditor5-indent';
import {Highlight} from '@ckeditor/ckeditor5-highlight';
import {PlainTableOutput, Table} from '@ckeditor/ckeditor5-table';

export const articleEditorPlugins = [
    Autoformat,
    Essentials,
    Bold,
    Italic,
    Indent,
    List,
    Link,
    Paragraph,
    Highlight,
    Table,
    PlainTableOutput,
];

/** setData → getData through the same editor build the article field uses. */
export async function roundTripArticleEditorHtml(html: string): Promise<string> {
    const host = document.createElement('div');
    document.body.appendChild(host);
    const editor = await InlineEditor.create(host, {
        plugins: articleEditorPlugins,
    });
    editor.setData(html || '');
    const data = editor.getData();
    await editor.destroy();
    host.remove();
    return data;
}
